import { ref } from 'vue';

// Track registration and update status
export const updateAvailable = ref(false);
export const offlineReady = ref(false);
export const registration = ref(null);

// Track installation status
export const canInstall = ref(false);
export const installPromptEvent = ref(null);

/**
 * Check if the device is running iOS
 */
export function isIOS() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent) && !window.MSStream;
}

/**
 * Check if the browser is Firefox
 */
export function isFirefox() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.indexOf('firefox') > -1;
}

/**
 * Check if the app is in standalone mode (already installed on home screen)
 */
export function isInStandaloneMode() {
  return (
    ('standalone' in window.navigator && window.navigator.standalone) ||
    window.matchMedia('(display-mode: standalone)').matches
  );
}

/**
 * Initialize PWA services
 */
export function initPWA() {
  // Listen for PWA updated event from registerServiceWorker.ts
  document.addEventListener('swUpdated', () => {
    // Auto-apply the update and reload
    navigator.serviceWorker.getRegistration().then((reg) => {
      if (reg && reg.waiting) {
        reg.waiting.postMessage({ type: 'SKIP_WAITING' });

        reg.waiting.addEventListener('statechange', (e) => {
          if (e.target && e.target.state === 'activated') {
            window.location.reload();
          }
        });
      }
    });

    // OR: Uncomment the line below if you want to show a manual update button instead
    // updateAvailable.value = true;
  });

  if ('serviceWorker' in navigator) {
    // Listen for the PWA install event (not fired on iOS or Firefox)
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      installPromptEvent.value = e;
      canInstall.value = true;
    });

    window.addEventListener('controllerchange', () => {
      console.log('Service Worker controller changed');
    });

    // iOS/Firefox edge case handler (already handled in UI if needed)
    if ((isFirefox() || isIOS()) && !isInStandaloneMode()) {
      // handled in component
    }
  }
}

/**
 * Prompt the user to install the PWA
 * Note: This method only works on supported browsers (Chrome, Edge, etc.)
 */
export async function installPWA() {
  if (installPromptEvent.value) {
    installPromptEvent.value.prompt();
    const choiceResult = await installPromptEvent.value.userChoice;

    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the install prompt');
      canInstall.value = false;
    } else {
      console.log('User dismissed the install prompt');
    }

    installPromptEvent.value = null;
  }
}

/**
 * Update the service worker to the latest version manually
 * (only needed if you use updateAvailable.value = true and prompt user)
 */
export function updateServiceWorker() {
  navigator.serviceWorker.getRegistration().then((reg) => {
    if (reg && reg.waiting) {
      reg.waiting.postMessage({ type: 'SKIP_WAITING' });

      reg.waiting.addEventListener('statechange', (e) => {
        if (e.target && e.target.state === 'activated') {
          window.location.reload();
        }
      });
    }
  });
}
